// ===========================================================================
// DimensionCard — tarjeta de UNA dimensión SDOH en el editor de estratificación.
// Selector de 4 niveles + base de la sugerencia + badge de origen. Al cambiar
// el nivel, la justificación es obligatoria (Save deshabilitado sin ella).
// ===========================================================================
import React, { useState } from "react";
import {
  Paper,
  Box,
  Typography,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Button,
  Chip,
} from "@mui/material";
import { SDOH_LEVELS } from "../../common/constants";

export default function DimensionCard({ dimension, onSave, saving }) {
  const [level, setLevel] = useState(dimension.level ?? 0);
  const [justification, setJustification] = useState("");

  const dirty = level !== (dimension.level ?? 0);
  const canSave = dirty && justification.trim().length > 0 && !saving;

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            {dimension.label}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {dimension.zCode}
          </Typography>
        </Box>
        {dimension.source === "auto_suggested" && (
          <Chip label="System suggested" size="small" color="warning" variant="outlined" />
        )}
        {dimension.source === "confirmed" && (
          <Chip label="Clinician confirmed" size="small" color="success" variant="outlined" />
        )}
      </Stack>

      <ToggleButtonGroup
        size="small"
        exclusive
        value={level}
        onChange={(_, v) => v !== null && setLevel(v)}
        sx={{ mt: 1.5, flexWrap: "wrap" }}
      >
        {SDOH_LEVELS.map((lvl) => (
          <ToggleButton
            key={lvl.key}
            value={lvl.value}
            sx={{
              textTransform: "none",
              fontSize: "0.72rem",
              px: 1.2,
              "&.Mui-selected": { bgcolor: lvl.color, color: "#fff", "&:hover": { bgcolor: lvl.color } },
            }}
          >
            {lvl.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      {dimension.suggestionBasis && (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
          Suggestion basis: {dimension.suggestionBasis}
        </Typography>
      )}

      {dirty && (
        <Box sx={{ mt: 1.5 }}>
          <TextField
            size="small"
            fullWidth
            required
            multiline
            minRows={2}
            label="Justification (required)"
            value={justification}
            onChange={(e) => setJustification(e.target.value)}
          />
          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 1 }}>
            <Button
              size="small"
              variant="contained"
              disabled={!canSave}
              onClick={() => onSave(dimension.key, level, justification.trim())}
              sx={{ textTransform: "none" }}
            >
              Save
            </Button>
          </Stack>
        </Box>
      )}
    </Paper>
  );
}
